import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag, Typography } from 'antd'
import { FC } from 'react'
import { LoyaltyTier } from '../../models/LoyaltyTier'
import { useAppSelector } from '../../store/hooks'
import { selectLoyaltyTierById } from '../../store/LoyaltyTierReducer'

const { Title } = Typography

type Props = SBModelComponent<LoyaltyTier> & {
  size?: 'small' | 'large'
}

const LoyaltyTierTag: FC<Props> = ({ id, model, size = 'small' }) => {
  const item = model ? model : useAppSelector(selectLoyaltyTierById(id!))

  if (!item) {
    return <></>
  }

  if (size === 'small') return <Tag color={item.color}>{item.title}</Tag>

  return (
    <Tag color={item.color}>
      <Title className="m-0" level={5} style={{ color: 'unset' }}>
        {item.title}
      </Title>
    </Tag>
  )
}

type LoyaltyTierTagType = { Tag: typeof LoyaltyTierTag }

export { LoyaltyTierTag, type LoyaltyTierTagType }
